import ChooseInformationOption from './GeneralnformationOption'

export default ChooseInformationOption
